import { render, staticRenderFns } from "./PCloseButton.vue?vue&type=template&id=30ac6124"
import script from "./PCloseButton.vue?vue&type=script&lang=js"
export * from "./PCloseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports